import axios from 'axios'
import { orderBy } from 'lodash'

export default {
  state: {
    job: null,
  },
  getters: {
    JOB: state => state.job,
    ATTACHMENTS (state) {
      return state.job ? orderBy(state.job.files, ['id'], ['desc']) : []
    },
    JOB_TASKS (state) {
      // return state.job ? orderBy(state.job.tasks, (obj) => parseInt(obj.seq_no), ['asc']) : []
      return state.job ? orderBy(state.job.tasks, ['due_date'], ['asc']) : []
    },
    JOB_QUOTES (state) {
      return state.job ? orderBy(state.job.quotes, ['id'], ['desc']) : []
    },
    JOB_INVOICES (state) {
      return state.job ? orderBy(state.job.invoices, ['id'], ['desc']) : []
    },
    JOB_ORDERS (state) {
      return state.job ? orderBy(state.job.orders, ['id'], ['desc']) : []
    }
  },
  mutations: {
    SET_JOB (state, obj) {
      state.job = obj;
    },
    ADD_ATTACHMENT (state, obj) {
      if (!state.job) return;
      state.job.files.push(obj);
    },
    ADD_TASK (state, obj) {
      if (!state.job) return;
      state.job.tasks.push(obj);
    },
    ADD_QUOTE (state, obj) {
      if (!state.job) return;
      state.job.quotes.push(obj);
    },
    ADD_INVOICE (state, obj) {
      if (!state.job) return;
      state.job.invoices.push(obj);
    },
    ADD_ORDER (state, obj) {
      if (!state.job) return;
      state.job.orders.push(obj);
    }
  },
  actions: {
    GET_JOB: async ( context, jobId ) => {
      context.commit('SET_JOB', false);
      let { data } = await axios.get( '/jobs/' + jobId )
      context.commit('SET_JOB', typeof(data.result) != 'undefined'? data.result: data);
      return typeof(data.result) != 'undefined'? data.result: data;
    },
    UPDATE_JOB ( context, job ) {
      context.commit('SET_JOB', job);
    },
    ADD_JOB_TASK ( context, task ) {
      context.commit('ADD_TASK', task);
    },
    ADD_JOB_QUOTE ( context, quote ) {
      context.commit('ADD_QUOTE', quote);
    },
    ADD_JOB_INVOICE ( context, invoice ) {
      context.commit('ADD_INVOICE', invoice);
    },
    ADD_JOB_ORDER ( context, order ) {
      context.commit('ADD_ORDER', order);
    }
  }
}
